import axios from 'axios';
const oauthUrl = '/api/v1/oauth';

export const fetchAuthorizationSession = ({ authorizationKey }) =>
  axios.get(`${oauthUrl}/authorization_sessions/${authorizationKey}`);

export const approve = ({ authorizationKey, scopes }) =>
  axios.post(
    `${oauthUrl}/authorization_sessions/${authorizationKey}/connections`,
    { scopes },
  );

export const deny = ({ authorizationKey }) =>
  axios.post(
    `${oauthUrl}/authorization_sessions/${authorizationKey}/cancel`,
    {},
  );
